import {useQuery} from "@tanstack/react-query";
import {readAccountTierInfoApi} from "../../../../../api/correspondent/CorresspondentApi";
import {CreateCorrespondentInterface} from "../../create/interface/CreateCorrespondentInterface";

type Props = {
    searchData: CreateCorrespondentInterface;
};

/**
 * 거래처 티어 정보
 * @param param
 * @returns
 */
export const useReadAccountTierInfo = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readAccountTierInfo", searchData],
        queryFn: async () => await readAccountTierInfoApi(searchData),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
